import { StandardEvents } from '@shopify/events';

/**
 * Nova Aura: aviso «Últimas unidades disponibles» encima de «Agregar al carrito».
 * El servidor decide si se muestra (stock real de la variante + producto sin reposición);
 * al cambiar de variante se copia el estado desde el HTML de sección que ya descarga el selector.
 */
class NovaStockNotice extends HTMLElement {
  /** @type {Element | null} */
  #scope = null;

  connectedCallback() {
    this.#scope = this.closest('.shopify-section, dialog');
    this.#scope?.addEventListener(StandardEvents.productSelect, this.#handleProductSelect);
  }

  disconnectedCallback() {
    this.#scope?.removeEventListener(StandardEvents.productSelect, this.#handleProductSelect);
    this.#scope = null;
  }

  /**
   * @param {Event & { promise?: Promise<any> }} event
   */
  #handleProductSelect = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;
    if (!event.promise) return;

    event.promise
      .then(({ detail }) => {
        if (!detail?.html) return;

        const { html, newProduct, productId } = detail;

        if (newProduct) {
          this.dataset.productId = newProduct.id;
        } else if (productId && productId !== this.dataset.productId) {
          return;
        }

        const next =
          html.querySelector(`nova-stock-notice[data-block-id="${this.dataset.blockId}"]`) ||
          html.querySelector('nova-stock-notice');

        // Sin aviso en la respuesta (p. ej. tarjeta regalo): ocultar por seguridad.
        this.hidden = next ? next.hasAttribute('hidden') : true;
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[nova-stock-notice] Event promise rejected:', error);
      });
  };
}

if (!customElements.get('nova-stock-notice')) {
  customElements.define('nova-stock-notice', NovaStockNotice);
}
